import { Sidebar } from './Sidebar';
import Header from '../Header';
import { ReactNode, useState } from 'react';

interface AppLayoutProps {
  children: ReactNode;
  firstName?: string;
  onLogout?: () => void;
  version?: string;
  pageTitle?: string;
}

export default function AppLayout({ children, firstName, onLogout, version, pageTitle }: AppLayoutProps) {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  return (
    <div className="flex h-screen bg-zinc-950 overflow-hidden">
      {/* Fixed Sidebar */}
      <div className={`hidden lg:flex lg:flex-col lg:fixed lg:inset-y-0 z-50 transition-all duration-300 ${
        sidebarCollapsed ? 'lg:w-20' : 'lg:w-72'
      }`}>
        <Sidebar onLogout={onLogout} onCollapsedChange={setSidebarCollapsed} />
      </div>

      {/* Main Content Area */}
      <div className={`flex flex-1 flex-col overflow-hidden transition-all duration-300 ${
        sidebarCollapsed ? 'lg:pl-20' : 'lg:pl-72'
      }`}>
        {/* Header (Topbar) */}
        <div className="sticky top-0 z-40 flex h-16 shrink-0 items-center gap-x-4 border-b border-white/5 bg-zinc-950/80 px-4 shadow-sm sm:gap-x-6 sm:px-6 lg:px-8 backdrop-blur-xl">
           {/* Full width for Header */}
           <div className="flex flex-1 gap-x-4 self-stretch lg:gap-x-6">
              <Header firstName={firstName} onLogout={onLogout} pageTitle={pageTitle} />
           </div>
        </div>

        {/* Page Content */}
        <main className="flex-1 overflow-y-auto pt-4 pb-0 scrollbar-thin scrollbar-thumb-zinc-800 scrollbar-track-transparent flex flex-col">
          <div className="px-4 sm:px-6 lg:px-8 flex-1">
            {children}
          </div>

          {/* Footer */}
          <footer className="mt-auto px-4 sm:px-6 lg:px-8 py-2 text-xs text-zinc-500 border-t border-white/5">
            <div className="flex flex-row items-center justify-between">
              <span>© 2025 Totemium - Tous droits réservés.</span>
              {version && (
                <span className="inline-flex items-center gap-2 rounded-full border border-emerald-500/20 bg-emerald-500/10 px-3 py-1 text-[10px] font-semibold uppercase tracking-widest text-emerald-400">
                  <span className="h-1.5 w-1.5 rounded-full bg-emerald-400 animate-pulse" />
                  v{version}
                </span>
              )}
            </div>
          </footer>
        </main>
      </div>
    </div>
  );
}
